import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IonicModule, Platform } from '@ionic/angular';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { HasPermissionDirective } from 'app/core/permission/has-permission.directive';
import { SummaryCardComponent } from './components/summary-card/summary-card.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { HeaderTitleComponent } from './components/header-title/header-title.component';
import { ButtonComponent } from './components/button/button.component';
import { TableComponent } from './components/table/table.component';
import {
    SkeletonBoxComponent,
    SkeletonTableComponent,
    SkeletonCardComponent,
    SkeletonDetailComponent,
} from './components/skeleton';

const SKELETON_COMPONENTS = [
    SkeletonBoxComponent,
    SkeletonTableComponent,
    SkeletonCardComponent,
    SkeletonDetailComponent,
];

@NgModule({
    declarations: [
        ...SKELETON_COMPONENTS,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HasPermissionDirective,
        SummaryCardComponent,
        PaginationComponent,
        HeaderTitleComponent,
        ButtonComponent,
        TableComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatTabsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatListModule,
        IonicModule,
        HasPermissionDirective,
        SummaryCardComponent,
        PaginationComponent,
        HeaderTitleComponent,
        ButtonComponent,
        TableComponent,
        ...SKELETON_COMPONENTS,
    ],
    providers: [Platform]
})
export class SharedModule
{
}

